'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var FocusLock = require('react-focus-lock');
var reactLaag = require('react-laag');
var reactTransitionGroup = require('react-transition-group');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
var button = require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
var date$1 = require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
var input = require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../utilities/color.js');
var container = require('../../../../utilities/container.js');
var date = require('../../../../utilities/date.js');
var locale = require('../../../../utilities/locale.js');
var refs = require('../../../../utilities/refs.js');
var usePrefersReducedMotion = require('../../../../hooks/use-prefers-reduced-motion.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('styled-components');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
var fadeIn = require('../../../../styles/transitions/fade-in.js');
require('../../../atoms/icon/font-icon/font-icon.js');
require('../../../atoms/alert/inline-alert/inline-alert.js');
require('../../../atoms/alert/standard-alert/standard-alert.js');
require('boring-avatars');
require('../../../atoms/tooltip/hover-tooltip/hover-tooltip.js');
require('@brandfolder/utilities');
var closeButton = require('../../../atoms/button/close-button/close-button.js');
require('../../../atoms/button/color-button/color-button.js');
var iconButton = require('../../../atoms/button/icon-button/icon-button.js');
require('../../../atoms/button/standard-button/standard-button.js');
require('../../../atoms/loader/circle-loader/circle-loader.js');
require('../../../atoms/loader/shimmer-loader/shimmer-loader.js');
require('../../../atoms/divider/standard-divider/standard-divider.js');
require('../../../atoms/fieldset/standard-fieldset/standard-fieldset.js');
require('../../../atoms/heading/standard-heading/standard-heading.js');
require('../../../atoms/label/standard-label/standard-label.js');
require('../../../atoms/link/button-link/button-link.js');
require('../../../atoms/link/standard-link/standard-link.js');
require('../../../atoms/popout/standard-popout/standard-popout.js');
require('../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js');
require('../../../atoms/table/standard-table/caption.js');
require('../../../atoms/table/standard-table/tbody.js');
require('../../../atoms/table/standard-table/tr-empty.js');
require('../../../atoms/table/standard-table/td.js');
require('../../../atoms/table/standard-table/tr.js');
require('../../../atoms/table/standard-table/table.js');
require('../../../atoms/table/standard-table/tfoot.js');
require('../../../atoms/table/standard-table/th.js');
require('../../../atoms/table/standard-table/thead.js');
require('../../../atoms/table/dnd-table/dnd-handle-td.js');
require('../../../atoms/table/dnd-table/dnd-table-drag-context.js');
require('../../../atoms/text/help-text/help-text.js');
require('../../../atoms/text/standard-text/standard-text.js');
require('../../../internal/list/standard-list/standard-list.js');
require('../../../internal/listbox/standard-listbox/standard-listbox.js');
require('../../../internal/listitem/standard-listitem/standard-listitem.js');
require('../../../internal/option/standard-option/standard-option.js');
require('../../../internal/textarea/fake-textarea.js');
require('../../../internal/textfield/textfield-addon.js');
var textfieldBody = require('../../../internal/textfield/textfield-body.js');
var textfieldHeader = require('../../../internal/textfield/textfield-header.js');
require('../../../internal/textfield/textfield-icon.js');
var textfieldInner = require('../../../internal/textfield/textfield-inner.js');
var textfieldWrapper = require('../../../internal/textfield/textfield-wrapper.js');
var baseTextfield = require('../../textfield/base-textfield/base-textfield.js');
require('../../textfield/standard-textfield/standard-textfield.js');
var baseColumnHeader = require('./base-column-header.js');
var baseGridCell = require('./base-grid-cell.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var FocusLock__default = /*#__PURE__*/_interopDefaultCompat(FocusLock);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseDatePicker = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { allowPastDates =true , bodyProps , calendarIconButtonProps , calendarProps , className , closeButtonProps , closeOnClickAway =true , closeOnSelection =true , columnHeaderProps , defaultOpen =false , defaultSelectedDate , dialogProps , disabled , error: externalError , errorPosition =input.InputErrorPositions.Bottom , errorProps , focusLock =true , focusLockProps , gridCellProps , gridProps , headerProps , headingProps , helpText , helpTextProps , id , innerProps , labelPosition =input.InputLabelPositions.Top , labelProps , labels , locale: defaultLocale = navigator?.language || '' , look , max , maxLength , min , minLength , name , nextMonthButtonProps , onBlur , onChange , onClose , onOpen , onSelection , pattern , previousMonthButtonProps , readOnly , required , rowProps , showCloseButton =false , showLabel =false , tbodyProps , textfieldProps , theadProps , todayProps , transitionDelay =0 , transitionDuration =200 , useLayerOptions , wrapperRef , ...otherProps } = props;
    const { changeDate , chooseDate , closeButton: closeButton$1 , invalidDateError , label , nextMonthButton , pastDateError , previousMonthButton , requiredLabel  } = labels;
    const now = new Date();
    const [calendar, setCalendar] = React.useState(null);
    const [columns, setColumns] = React.useState([]);
    const [currentDate, setCurrentDate] = React.useState(now);
    const [internalError, setInternalError] = React.useState('');
    const [initialDate, setInitialDate] = React.useState(date.convertToDate(defaultSelectedDate));
    const [locale$1, setLocale] = React.useState(locale.getInputFormatLocale(defaultLocale));
    const [mounted, setMounted] = React.useState(false);
    const [open, setOpen] = React.useState(defaultOpen || false);
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [value, setValue] = React.useState('');
    const error = externalError || internalError || '';
    const hasError = !!externalError || !!internalError;
    const hasHelpText = !!helpText;
    const hasRequired = required && !!requiredLabel;
    const calendarIconButtonId = `${id}-calendar-icon-button`;
    const dialogId = `${id}-dialog`;
    const headingId = `${id}-heading`;
    const helpTextId = `${id}-help-text`;
    const inlineAlertId = `${id}-inline-alert`;
    const wrapperId = `${id}-wrapper`;
    const timeout = transitionDelay ? transitionDelay + transitionDuration : transitionDuration;
    const calendarIconButtonRef = React.useRef(null);
    const currentDateRef = React.useRef(null);
    const nodeRef = React.useRef(null);
    const prefersReducedMotion = usePrefersReducedMotion.usePrefersReducedMotion();
    const handleClose = (focusCalendarIconButton = true)=>{
        setOpen(false);
        // when closing, the focus needs to return to the calendar icon button
        if (focusCalendarIconButton && calendarIconButtonRef.current) {
            // this is a little hacky but required
            // focusing on this ref has a timing conflict with onKeyDown below
            // causing the calendar to reopen after being closed on selection
            // so we need a little delay before focusing
            setTimeout(()=>{
                calendarIconButtonRef.current?.focus();
            }, 100);
        }
        if (onClose) onClose();
    };
    const handleOpen = ()=>{
        setOpen(true);
        if (onOpen) onOpen();
    };
    const handleFuture = (date$1)=>{
        if (!allowPastDates && initialDate && date.beforeDate(date$1, now) && !date.todayDate(date$1)) {
            return now;
        }
        return date$1;
    };
    const handleNextDay = ()=>setCurrentDate(handleFuture(date.addDay(currentDate)));
    const handleNextMonth = ()=>setCurrentDate(handleFuture(date.addMonth(currentDate)));
    const handleNextWeek = ()=>setCurrentDate(handleFuture(date.addWeek(currentDate)));
    const handleNextYear = ()=>setCurrentDate(handleFuture(date.addYear(currentDate)));
    const disablePreviousMonth = ()=>{
        if (!allowPastDates && initialDate) {
            return date.beforeDate(initialDate, now) ? date.beforeDate(date.subMonth(currentDate), initialDate) && date.sameMonth(currentDate, initialDate) : date.sameMonth(currentDate, now);
        }
        if (!allowPastDates && !initialDate) {
            return date.beforeDate(date.subMonth(currentDate), now) && date.sameMonth(currentDate, now);
        }
        return false;
    };
    const handlePast = (date$1, paging)=>{
        if (!allowPastDates && paging) {
            return date$1;
        }
        if (!allowPastDates && initialDate && date.beforeDate(date$1, now) && !date.todayDate(date$1)) {
            return now;
        }
        if (!allowPastDates && !initialDate && date.beforeDate(date$1, now) && !date.todayDate(date$1)) {
            return currentDate;
        }
        return date$1;
    };
    const handlePreviousDay = ()=>setCurrentDate(handlePast(date.subDay(currentDate)));
    const handlePreviousMonth = (paging)=>setCurrentDate(handlePast(date.subMonth(currentDate), paging));
    const handlePreviousWeek = ()=>setCurrentDate(handlePast(date.subWeek(currentDate)));
    const handlePreviousYear = ()=>setCurrentDate(handlePast(date.subYear(currentDate)));
    const handleWeekEnd = ()=>setCurrentDate(date.endWeek(currentDate));
    const handleWeekStart = ()=>setCurrentDate(handlePast(date.startWeek(currentDate)));
    const handleDate = (maybeDate, callback, checkPastDate = true)=>{
        const { date: date$1 , dateValue , valid  } = date.validateDate(locale$1.inputFormat.format, maybeDate);
        if (valid) {
            if (checkPastDate && !allowPastDates && date.beforeDate(date$1, now) && !date.todayDate(date$1)) {
                setInternalError(pastDateError);
            } else {
                setCurrentDate(date$1);
                setInternalError('');
                setSelectedDate(date$1);
                setValue(dateValue);
                if (callback) {
                    callback(date$1);
                }
            }
        } else {
            setInternalError(invalidDateError);
        }
    };
    const handleSelectedDate = (date)=>{
        handleDate(date, onSelection);
        if (closeOnSelection) handleClose();
    };
    const handleInputDate = (e)=>{
        if (e.target.value) {
            handleDate(e.target.value, onSelection);
        } else {
            // user cleared their typed date, reset error
            setInternalError('');
        }
    };
    const handleSelectedDateKeyDown = (e)=>{
        const { key , shiftKey  } = e;
        switch(key){
            case 'Enter':
                {
                    handleSelectedDate(currentDate);
                    break;
                }
            case 'Escape':
                {
                    handleClose();
                    break;
                }
            case ' ':
                {
                    handleSelectedDate(currentDate);
                    break;
                }
            case 'PageUp':
                {
                    e.preventDefault();
                    if (shiftKey) {
                        handlePreviousYear();
                    } else {
                        handlePreviousMonth();
                    }
                    break;
                }
            case 'PageDown':
                {
                    e.preventDefault();
                    if (shiftKey) {
                        handleNextYear();
                    } else {
                        handleNextMonth();
                    }
                    break;
                }
            case 'End':
                {
                    e.preventDefault();
                    handleWeekEnd();
                    break;
                }
            case 'Home':
                {
                    e.preventDefault();
                    handleWeekStart();
                    break;
                }
            case 'ArrowLeft':
                {
                    e.preventDefault();
                    handlePreviousDay();
                    break;
                }
            case 'ArrowUp':
                {
                    e.preventDefault();
                    handlePreviousWeek();
                    break;
                }
            case 'ArrowRight':
                {
                    e.preventDefault();
                    handleNextDay();
                    break;
                }
            case 'ArrowDown':
                {
                    e.preventDefault();
                    handleNextWeek();
                    break;
                }
        }
    };
    const createCalendar = ()=>{
        setCalendar(date.generateCalendar(currentDate));
        setColumns(date.generateColumns(now, locale$1.locale));
    };
    React.useEffect(()=>{
        setMounted(true);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (mounted) {
            setInitialDate(date.convertToDate(defaultSelectedDate, locale$1.inputFormat.format));
        }
    }, [
        defaultSelectedDate
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (initialDate) {
            handleDate(initialDate, undefined, false);
        }
    }, [
        initialDate
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (open) {
            // initial calendar render on open
            createCalendar();
        }
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (mounted) {
            setLocale(locale.getInputFormatLocale(defaultLocale));
        }
    }, [
        defaultLocale
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (mounted) {
            // the calendar displays different between locales
            createCalendar();
        }
    }, [
        locale$1
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (mounted) {
            // needs to rerun when going from month to month
            createCalendar();
        }
    }, [
        currentDate
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (mounted) {
            // focus on the current date when the calendar changes
            currentDateRef.current?.focus();
        }
    }, [
        calendar
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (mounted) {
            setOpen(defaultOpen || false);
        }
    }, [
        defaultOpen
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const { layerProps , renderLayer , triggerProps  } = reactLaag.useLayer({
        auto: true,
        container: container.getContainer(wrapperId),
        containerOffset: 0,
        overflowContainer: true,
        placement: date$1.DatePickerPlacements.BottomStart,
        possiblePlacements: Object.keys(date$1.DatePickerPlacements),
        snap: true,
        triggerOffset: 8,
        ...useLayerOptions,
        isOpen: open,
        onOutsideClick: closeOnClickAway ? ()=>{
            handleClose();
            if (useLayerOptions?.onOutsideClick) useLayerOptions.onOutsideClick();
        } : useLayerOptions?.onOutsideClick
    });
    const { ref: layerRef , style: layerPropsStyle , ...otherLayerProps } = layerProps;
    const renderCalendar = ()=>/*#__PURE__*/ React__default.default.createElement("div", _extends({}, calendarProps, {
            className: classnames__default.default({
                'bf-date-picker__calendar': true,
                [`${calendarProps?.className}`]: !!calendarProps?.className
            })
        }), /*#__PURE__*/ React__default.default.createElement("div", _extends({}, headerProps, {
            className: classnames__default.default({
                'bf-date-picker__header': true,
                [`${headerProps?.className}`]: !!headerProps?.className
            })
        }), /*#__PURE__*/ React__default.default.createElement("h6", _extends({}, headingProps, {
            "aria-live": "polite",
            className: classnames__default.default({
                'bf-date-picker__heading': true,
                [`${headingProps?.className}`]: !!headingProps?.className
            }),
            id: headingId
        }), date.formatDate(currentDate, 'MMMM yyyy', locale$1.locale)), /*#__PURE__*/ React__default.default.createElement(iconButton.IconButton, _extends({}, previousMonthButtonProps, {
            className: classnames__default.default({
                'bf-date-picker__header-button': true,
                'bf-date-picker__previous-month-button': true,
                [`${previousMonthButtonProps?.className}`]: !!previousMonthButtonProps?.className
            }),
            disabled: disablePreviousMonth(),
            icon: fontIcon.FontIcons.CaretLeft,
            label: previousMonthButton,
            look: button.ButtonLooks.Default,
            onClick: (e)=>{
                handlePreviousMonth(true);
                if (previousMonthButtonProps?.onClick) {
                    previousMonthButtonProps.onClick(e);
                }
            },
            onKeyDown: (e)=>{
                if (e.key === 'Enter') handlePreviousMonth(true);
                if (previousMonthButtonProps?.onKeyDown) {
                    previousMonthButtonProps.onKeyDown(e);
                }
            }
        })), /*#__PURE__*/ React__default.default.createElement(iconButton.IconButton, _extends({}, nextMonthButtonProps, {
            className: classnames__default.default({
                'bf-date-picker__header-button': true,
                'bf-date-picker__next-month-button': true,
                [`${nextMonthButtonProps?.className}`]: !!nextMonthButtonProps?.className
            }),
            icon: fontIcon.FontIcons.CaretRight,
            label: nextMonthButton,
            look: button.ButtonLooks.Default,
            onClick: (e)=>{
                handleNextMonth();
                if (nextMonthButtonProps?.onClick) {
                    nextMonthButtonProps.onClick(e);
                }
            },
            onKeyDown: (e)=>{
                if (e.key === 'Enter') handleNextMonth();
                if (nextMonthButtonProps?.onKeyDown) {
                    nextMonthButtonProps.onKeyDown(e);
                }
            }
        })), /*#__PURE__*/ React__default.default.createElement(closeButton.CloseButton, _extends({}, closeButtonProps, {
            "aria-label": closeButton$1,
            className: classnames__default.default({
                'bf-date-picker__header-button': true,
                'bf-date-picker__close-button': true,
                'bf-date-picker__close-button--hidden': !showCloseButton,
                [`${closeButtonProps?.className}`]: !!closeButtonProps?.className
            }),
            onClick: (e)=>{
                handleClose();
                if (closeButtonProps?.onClick) {
                    closeButtonProps.onClick(e);
                }
            },
            onKeyDown: (e)=>{
                if (e.key === 'Enter') handleClose();
                if (closeButtonProps?.onKeyDown) {
                    closeButtonProps.onKeyDown(e);
                }
            }
        }))), /*#__PURE__*/ React__default.default.createElement("table", _extends({}, gridProps, {
            "aria-labelledby": headingId,
            className: classnames__default.default({
                'bf-date-picker__grid': true,
                [`${gridProps?.className}`]: !!gridProps?.className
            }),
            role: "grid"
        }), /*#__PURE__*/ React__default.default.createElement("thead", _extends({}, theadProps, {
            className: classnames__default.default({
                'bf-date-picker__thead': true,
                [`${theadProps?.className}`]: !!theadProps?.className
            })
        }), /*#__PURE__*/ React__default.default.createElement("tr", _extends({}, rowProps, {
            className: classnames__default.default({
                'bf-date-picker__row': true,
                [`${rowProps?.className}`]: !!rowProps?.className
            })
        }), columns.map((column)=>/*#__PURE__*/ React__default.default.createElement(baseColumnHeader.BaseColumnHeader, _extends({}, columnHeaderProps, {
                column: column,
                key: column.abbr
            }))))), /*#__PURE__*/ React__default.default.createElement("tbody", _extends({}, tbodyProps, {
            className: classnames__default.default({
                'bf-date-picker__tbody': true,
                [`${tbodyProps?.className}`]: !!tbodyProps?.className
            })
        }), calendar && calendar.map((week, w)=>/*#__PURE__*/ React__default.default.createElement("tr", _extends({}, rowProps, {
                className: classnames__default.default({
                    'bf-date-picker__row': true,
                    [`${rowProps?.className}`]: !!rowProps?.className
                }),
                key: `${id}-week-${w}`,
                role: "row"
            }), week.map((day, d)=>{
                const key = `${id}-week-${w}-day-${d}`;
                if (!day) {
                    return /*#__PURE__*/ React__default.default.createElement(baseGridCell.BaseGridCell, {
                        key: key
                    });
                }
                const today = date.todayDate(day);
                const isBeforeToday = date.beforeDate(day, now);
                const isCurrentDate = date.sameDay(currentDate, day);
                const isInitialDate = initialDate ? date.sameDay(initialDate, day) : false;
                const isDisabled = !isInitialDate && !allowPastDates && isBeforeToday && !today;
                const isSelectedDate = !!selectedDate && date.sameDay(selectedDate, day);
                return /*#__PURE__*/ React__default.default.createElement(baseGridCell.BaseGridCell, _extends({}, gridCellProps, {
                    "aria-disabled": isDisabled,
                    "aria-selected": isSelectedDate,
                    key: key,
                    onClick: isDisabled ? undefined : ()=>handleSelectedDate(day),
                    onKeyDown: isDisabled ? undefined : (e)=>handleSelectedDateKeyDown(e),
                    ref: isCurrentDate ? currentDateRef : undefined,
                    tabIndex: isCurrentDate ? 0 : -1,
                    title: date.formatDate(day, 'eeee, MMMM d, yyyy', locale$1.locale)
                }), date.formatDate(day, 'd', locale$1.locale), today && /*#__PURE__*/ React__default.default.createElement("span", _extends({}, todayProps, {
                    "aria-hidden": true,
                    className: classnames__default.default({
                        'bf-date-picker__today': true,
                        [`${todayProps?.className}`]: !!todayProps?.className
                    }),
                    role: "img"
                })));
            }))))));
    return /*#__PURE__*/ React__default.default.createElement(textfieldWrapper.TextfieldWrapper, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-date-picker': true,
            'bf-date-picker--disabled': disabled,
            'bf-date-picker--error': hasError,
            'bf-date-picker--help-text': hasHelpText,
            [`bf-date-picker--label-${labelPosition}`]: showLabel,
            'bf-date-picker--label-hidden': !showLabel,
            [`bf-date-picker--look-${look}`]: look,
            'bf-date-picker--readonly': readOnly,
            'bf-date-picker--required': hasRequired,
            [`${className}`]: !!className
        }),
        id: wrapperId,
        labelPosition: labelPosition,
        ref: wrapperRef
    }), /*#__PURE__*/ React__default.default.createElement(textfieldHeader.TextfieldHeader, _extends({}, headerProps, {
        error: error,
        errorPosition: errorPosition,
        errorProps: errorProps,
        htmlFor: id,
        inlineAlertId: inlineAlertId,
        label: label,
        labelPosition: labelPosition,
        labelProps: labelProps,
        required: required,
        requiredLabel: requiredLabel,
        showLabel: showLabel
    })), /*#__PURE__*/ React__default.default.createElement(textfieldBody.TextfieldBody, _extends({}, bodyProps, triggerProps, {
        disabled: disabled,
        error: error,
        errorPosition: errorPosition,
        errorProps: errorProps,
        helpText: helpText,
        helpTextId: helpTextId,
        helpTextProps: helpTextProps,
        inlineAlertId: inlineAlertId,
        labelPosition: labelPosition,
        look: look
    }), /*#__PURE__*/ React__default.default.createElement(textfieldInner.TextfieldInner, _extends({}, innerProps), /*#__PURE__*/ React__default.default.createElement(baseTextfield.BaseTextfield, _extends({}, textfieldProps, {
        "aria-describedby": hasError ? inlineAlertId : hasHelpText ? helpTextId : undefined,
        "aria-disabled": disabled,
        "aria-invalid": hasError,
        className: classnames__default.default({
            'bf-date-picker__textfield': true,
            [`${textfieldProps?.className}`]: !!textfieldProps?.className
        }),
        disabled: disabled,
        id: id,
        max: max,
        maxLength: maxLength,
        min: min,
        minLength: minLength,
        name: name,
        onBlur: (e)=>{
            handleInputDate(e);
            if (onBlur) onBlur(e);
        },
        onChange: (e)=>{
            setValue(e.target.value);
            if (onChange) onChange(e);
        },
        onFocus: (e)=>{
            handleClose(false);
            if (textfieldProps?.onFocus) {
                textfieldProps.onFocus(e);
            }
        },
        pattern: pattern,
        placeholder: locale$1.inputFormat.placeholder,
        readOnly: readOnly,
        ref: ref,
        required: required,
        value: value
    })), /*#__PURE__*/ React__default.default.createElement(iconButton.IconButton, _extends({}, calendarIconButtonProps, {
        className: classnames__default.default({
            'bf-date-picker__calendar-icon-button': true,
            [`${calendarIconButtonProps?.className}`]: !!calendarIconButtonProps?.className
        }),
        disabled: disabled || readOnly,
        icon: fontIcon.FontIcons.Calendar,
        id: calendarIconButtonId,
        label: selectedDate ? `${changeDate} ${date.formatDate(selectedDate, 'eeee, MMMM d, yyyy', locale$1.locale)}` : chooseDate,
        look: button.ButtonLooks.Default,
        onClick: (e)=>{
            open ? handleClose() : handleOpen();
            if (calendarIconButtonProps?.onClick) {
                calendarIconButtonProps.onClick(e);
            }
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter') open ? handleClose() : handleOpen();
            if (calendarIconButtonProps?.onKeyDown) {
                calendarIconButtonProps.onKeyDown(e);
            }
        },
        ref: calendarIconButtonRef
    })))), renderLayer(/*#__PURE__*/ React__default.default.createElement(reactTransitionGroup.Transition, {
        appear: open,
        in: open,
        mountOnEnter: true,
        timeout: timeout,
        unmountOnExit: true
    }, (transitionStatus)=>/*#__PURE__*/ React__default.default.createElement("div", _extends({}, dialogProps, otherLayerProps, {
            "aria-label": chooseDate,
            "aria-modal": true,
            className: classnames__default.default({
                'bf-date-picker__dialog': true,
                [`${dialogProps?.className}`]: !!dialogProps?.className
            }),
            id: dialogId,
            ref: refs.mergeRefs([
                nodeRef,
                layerRef
            ]),
            role: "dialog",
            style: {
                ...dialogProps?.style,
                ...layerPropsStyle,
                ...!prefersReducedMotion && transitionDuration > 0 && fadeIn.transitionFadeIn({
                    transitionDelay,
                    transitionDuration,
                    transitionStatus
                })
            }
        }), focusLock ? /*#__PURE__*/ React__default.default.createElement(FocusLock__default.default, _extends({}, focusLockProps, {
            className: classnames__default.default({
                'bf-date-picker__focus-lock': true,
                [`${focusLockProps?.className}`]: !!focusLockProps?.className
            }),
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: focusLockProps?.autoFocus || false,
            crossFrame: focusLockProps?.crossFrame || false
        }), renderCalendar()) : renderCalendar()))));
});

exports.BaseDatePicker = BaseDatePicker;
//# sourceMappingURL=base-date-picker.js.map
